import { __decorate, __metadata } from "tslib";
import { CameraObject } from './CameraObject';
import { SerializableObject, SerializableMember } from '@openhps/core';
import { PerspectiveCameraObject } from './PerspectiveCameraObject';
let StereoCameraObject = class StereoCameraObject extends CameraObject {
    constructor(uid, displayName, left, right) {
        super(uid, displayName);
        /**
         * Camera eye separation
         * @default 0.064
         */
        this.eyeSep = 0.064;
        this.cameraL = left;
        this.cameraR = right;
        if (left !== undefined && right !== undefined) {
            this.uid = left.uid + right.uid;
        }
    }
};
__decorate([
    SerializableMember(),
    __metadata("design:type", PerspectiveCameraObject)
], StereoCameraObject.prototype, "cameraL", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", PerspectiveCameraObject)
], StereoCameraObject.prototype, "cameraR", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Object)
], StereoCameraObject.prototype, "eyeSep", void 0);
StereoCameraObject = __decorate([
    SerializableObject(),
    __metadata("design:paramtypes", [String, String, PerspectiveCameraObject, PerspectiveCameraObject])
], StereoCameraObject);
export { StereoCameraObject };
//# sourceMappingURL=StereoCameraObject.js.map